import { useRef } from "react";
import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

// Magnetic wrapper — subtle pull toward cursor on desktop.
export default function Magnetic({ children, strength = 0.35, className = "" }) {
    const ref = useRef(null);
    const rm = useReducedMotion();
    const x = useMotionValue(0);
    const y = useMotionValue(0);
    const sx = useSpring(x, { stiffness: 180, damping: 15, mass: 0.3 });
    const sy = useSpring(y, { stiffness: 180, damping: 15, mass: 0.3 });

    const onMove = (e) => {
        if (rm) return;
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        x.set((e.clientX - (r.left + r.width / 2)) * strength);
        y.set((e.clientY - (r.top + r.height / 2)) * strength);
    };
    const onLeave = () => {
        x.set(0);
        y.set(0);
    };

    return (
        <motion.div
            ref={ref}
            data-magnetic
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            style={{ x: sx, y: sy, display: "inline-block" }}
            className={className}
        >
            {children}
        </motion.div>
    );
}
